import { Log } from 'ng2-logger';
import Types, { GlobalState } from '../../models/action/core.d';
import * as Actions from '../constants/translations';
import { IGlobalization, IRefreshGlobalization, ISetGlobalizationList } from '../../models/action/translation';

const _logger = Log.create('Translation Reducer');

const translationReducer = (state = GlobalState().translation, action: Types.IAction) => {
    if (!state) {
        return state;
    }
    const newState: any = { ...state };
    if (action.type === Actions.actions.SET_LIST_GLOBALIZATION) {
        const pageActionPayload = (action as ISetGlobalizationList);
        const results = pageActionPayload.results ?? [];
        const filters = pageActionPayload.filters ?? {};
        newState.translationList = { filters, results };

    } else if (action.type === Actions.actions.REFRESH_GLOBALIZATION_LIST) {
        const currentData: IGlobalization[] = state.translationList.results;
        const pageData = (action as IRefreshGlobalization);

        const updatedData = currentData.map((item) =>
            item.globalizationId === pageData.globalizationData.globalizationId
                ? { ...item, globalizationValue: pageData.globalizationData.globalizationValue }
                : item
        );

        newState.translationList = {
            filters: state.translationList.filters,
            results: updatedData
        };
    }
    return Object.assign({}, state, newState);
};

export default translationReducer;

